import React from 'react';
import { motion } from 'framer-motion';
import { socialProofImages } from '../data/copy';
export function SocialProof() {
  return <section className="w-full border-y-2 border-bone/10 bg-steel py-12 sm:py-20" data-id="element-131" data-mp="3lufhfe2eagwd">
      <div className="mx-auto max-w-6xl px-4 sm:px-8" data-id="element-132" data-mp="36wn2an0rfuip">
        <div className="mb-8 text-center sm:mb-12" data-id="element-133" data-mp="3buomjb9x9zvr">
          <p className="font-cond text-xs uppercase tracking-[0.28em] text-chartreuse sm:text-sm" data-id="element-134" data-mp="3bvg8dudpwj8u">
            Corrida 4 de la temporada
          </p>
          <h2 className="mt-2 font-display text-2xl uppercase leading-[0.95] text-bone sm:mt-3 sm:text-4xl" data-id="element-135" data-mp="8doj4nqyudec">
            Más de 2,500 packs probados en el agua
          </h2>
        </div>

        <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 sm:gap-4 md:grid-cols-6" data-id="element-136" data-mp="3utj0ii1kawav">
          {socialProofImages.map((img, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="relative aspect-square overflow-hidden rounded-sm border border-bone/10 bg-abyss" data-id="element-137" data-mp="mdh8ofqrankq" data-mpi={i}>
              <img src={img} alt="Cliente con lobina" className="h-full w-full object-cover" data-id="element-138" data-mp="23zo15hor1xaa" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}